import { Box, Typography, Paper, Table, TableBody, TableCell, TableHead, TableRow, TablePagination, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Category } from '@mui/icons-material';
import { useGetList } from 'react-admin';
import { useState } from 'react';
import { ListPageHeader } from '@/components/ListPageHeader';

const STATUSES = ['Active', 'Inactive'];

export const QualificationTypeList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState<Record<string, string | undefined>>({});
  const { data: allTypes, isLoading } = useGetList('qualification-types', { pagination: { page: 1, perPage: 1000 }, filter: filters });
  const types = allTypes?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const stats = {
    total: allTypes?.length ?? 0,
  };

  return (
    <Box sx={{ p: 2 }}>
      <ListPageHeader
        title="Qualification Types"
        metrics={[
          { label: 'Total', value: String(stats.total), color: 'primary.main' },
        ]}
      />
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={filters.status || ''}
            label="Status"
            onChange={e => setFilters(prev => ({ ...prev, status: e.target.value || undefined }))}
          >
            <MenuItem value="">All</MenuItem>
            {STATUSES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
      <Paper sx={{ overflow: 'hidden' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'action.hover' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Level</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Credits</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {types?.map((type: { id: string; name: string; description?: string; level?: string; credits?: number }) => (
              <TableRow
                key={type.id}
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(`/qualification-types/${type.id}/show`)}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>{type.name}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{type.description || '—'}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{type.level || '—'}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{type.credits || '—'}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={allTypes?.length ?? 0}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{ borderTop: '1px solid', borderColor: 'divider' }}
        />
        {(!types || types.length === 0) && (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Category sx={{ fontSize: 48, color: 'grey.300', mb: 1 }} />
            <Typography color="text.secondary">No qualification types found</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
